import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { ShieldCheck, Lock, CreditCard, Star, XCircle } from 'lucide-react';
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-289" data-mp="mz5vbfm4mugs">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-290" data-mp="rubpf1ponffy">
        <FadeIn data-id="element-291" data-mp="wqsato5hzfpc">
          <div className="space-y-2 md:space-y-4" data-id="element-292" data-mp="wteo84f2kpfh">
            <div className="inline-flex items-center gap-1.5 bg-bg-card text-brandGold font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandGold/40" data-id="element-293" data-mp="3va0ptrn0py7b">
              <span className="text-sm md:text-base" data-id="element-294" data-mp="90fz0274syth">🎨</span>
              <span className="text-[8.5px]" data-id="element-295" data-mp="e13x17ts2fx7">
                MEGAPACK COLORIMETRÍA LISTA™
              </span>
            </div>
            <h1 className="font-hero font-bold uppercase text-[28px] md:text-[54px] leading-[1.1] tracking-[0.5px] text-txt-primary px-2 pt-3 pb-1" data-id="element-296" data-mp="1kgeaecps7wxv">
              CURSO COMPLETO DE COLORIMETRÍA 
              <br data-id="element-297" data-mp="1h9shi74nriwf" />
              <span className="text-brandGold" data-id="element-298" data-mp="1h87vj5wet8a6"> ORGANIZADO EN UN SOLO LUGAR.</span>
            </h1>

            <p className="text-txt-body text-[12.5px] md:text-[16px] leading-[1.4] md:leading-[1.7] font-sans px-3" data-id="element-299" data-mp="1c94ojfwvcrzk">
              15 Módulos en Video · 4 Manuales Completos · 5 Bonos · Todo
              imprimible
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-300" data-mp="yc82rsvly0pj">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-301" data-mp="ydj4ln5hsye0">
            <div className="absolute inset-0 bg-brandGold/15 blur-[40px] rounded-full" data-id="element-302" data-mp="tjy67tzzm2ea"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandGold/10 blur-[28px] rounded-full" data-id="element-303" data-mp="omg5gqw4ithd"></div>
            <img src="https://cdn.magicpatterns.com/uploads/agacHF4oUprc8XhkQK75E2/mockup_sticker.png" alt="Megapack Colorimetría Lista — Mockup completo del producto" loading="eager" decoding="async"
          // @ts-ignore — supported by modern browsers
          fetchpriority="high" className="relative block w-full max-w-[300px] md:max-w-[560px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-304" data-mp="klcscc5gnbju" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-305" data-mp="3n6j5ib8kt3yz">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-306" data-mp="3n7apspwq3f9y">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-307" data-mp="3s6dug98sjjhe">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-308" data-mp="jr3namq1no2r">
                <span className="text-[10px] md:text-xs" data-id="element-309" data-mp="9x3kiri8iux7">📄</span> 100% PDF +
                Videos HD
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-310" data-mp="12n3ie6ebj7qk">
                <span className="text-[10px] md:text-xs" data-id="element-311" data-mp="2s47dhmzgcgqb">⚡</span> Acceso en 5
                min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-312" data-mp="2n4mi1mjhqqic">
                <span className="text-[10px] md:text-xs" data-id="element-313" data-mp="2wws6wneg4rtb">📚</span> 475+ páginas
                + 14 h de video
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-314" data-mp="247l61hrirq4w">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[15px] md:!text-base" data-id="element-315" data-mp="2494s5ozuwvel">
                🎨 DOMINA LA COLORIMETRÍA AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-xs text-txt-muted font-sans" data-id="element-316" data-mp="2e3od9218aeyp">
                <span className="flex items-center gap-1" data-id="element-317" data-mp="3pkeiahtx10qq">
                  <ShieldCheck size={11} className="text-success" data-id="element-318" data-mp="3pm7hxd642kp8" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-319" data-mp="sqinflsq8t6s">
                  <Lock size={11} className="text-txt-muted" data-id="element-320" data-mp="sr0p4xy5rzm3" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-321" data-mp="xo0n0lkutw24">
                  <CreditCard size={11} className="text-brandGold" data-id="element-322" data-mp="12p7uskmzyv8s" /> Pagas en
                  tu moneda local
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+500',
    label: 'barberos dominan con esto'
  }, {
    value: '15',
    label: 'Módulos en video'
  }, {
    value: '4',
    label: 'Manuales PDF'
  }, {
    value: '5',
    label: 'Bonos incluidos'
  }, {
    value: '4.9/5',
    label: 'calificación',
    star: true
  }];
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-323" data-mp="1vddfx8hyqm95">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-324" data-mp="1vdvjkq6yg2r3">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-center divide-x divide-line" data-id="element-325" data-mp="3fv4t8ir31ed6">
          {stats.map((stat, i) => <FadeIn key={stat.label} delay={0.1 + i * 0.1} data-id="element-326" data-mp="3aw1t9cpylyc2" data-mpi={i}>
              <div className="font-display font-bold text-[30px] md:text-[42px] leading-[1.1] text-brandGold mb-0.5" data-id="element-327" data-mp="35x8hboqbmfe0">
                {stat.value}
              </div>
              <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-328" data-mp="30zovo3ran0c1">
                {stat.label}
                {stat.star && <Star size={12} className="fill-gold text-gold" data-id="element-329" data-mp="3tn2vc9mdm9zu" />}
              </div>
            </FadeIn>)}
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'JM',
    text: 'Tenía miedo a los platinados. Con esto hago blancos puros. Ahora cobro el triple.',
    author: 'Juan M.',
    role: 'Barbero Profesional · Argentina',
    bg: 'bg-brandGold text-[#14100A]'
  }, {
    initials: 'CS',
    text: 'Estandaricé el servicio de color en mi equipo. Todos hacen lo mismo. Sin errores.',
    author: 'Carlos S.',
    role: 'Dueño de Barbería · México',
    bg: 'bg-brandSteel-deep text-white'
  }, {
    initials: 'RF',
    text: 'Imprimí los manuales. Los tengo en mi local. En cada cliente sé exactamente qué fórmula usar.',
    author: 'Roberto F.',
    role: 'Colorista · Colombia',
    bg: 'bg-brandGold text-[#14100A]'
  }];
  return <Section className="bg-bg-base" data-id="element-330" data-mp="1rxvhz9067fy8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-331" data-mp="1rwu9ncajh7k7">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-332" data-mp="1w00au5iso8jt" data-mpi={i}>
            <div className="bg-bg-card p-3.5 md:p-5 rounded-[14px] md:rounded-[18px] border border-line h-full flex flex-col" data-id="element-333" data-mp="1hzpmb94yj61t">
              <div className="flex items-center gap-2.5 mb-2.5" data-id="element-334" data-mp="1mzlmsyeg4fcm">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-xs shrink-0`} data-id="element-335" data-mp="3cdqifm94hey7">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-336" data-mp="15of27yexloou">
                  <div className="flex text-gold mb-0.5" data-id="element-337" data-mp="15phqdykvdd12">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-338" data-mp="10roohhqln56l" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[12px] md:text-[13px] leading-tight" data-id="element-339" data-mp="1fgksn3pjby1x">
                    {t.author}
                  </p>
                  <p className="text-[10px] md:text-[11px] font-sans text-txt-muted" data-id="element-340" data-mp="1of6fvc5yc191">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[12.5px] md:text-[13.5px] leading-[1.5] italic" data-id="element-341" data-mp="1ydvo0d81q7c3">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandGold mt-auto pt-2.5" data-id="element-342" data-mp="1tg3whkbbcn8f">
                Compró el Megapack
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Aprendiste técnicas en un lugar, fórmulas en otro o buscando videos por tu cuenta', 'No tienes UN SISTEMA donde sepas EXACTAMENTE cómo mezclar, decolorar y neutralizar sin arruinar el cabello', 'Repites los mismos trabajos porque no tienes un banco completo de diseños y técnicas organizadas', 'Un cliente nuevo pide un "platinado blanco" y no sabes que tintura utilizar exactamente', 'Conoces mucho pero no lo dominas realmente por falta de confianza', 'Cada mes pierdes ingresos extras por rechazar trabajos o cobrarlos a un precio que no te rinde'];
  return <Section className="bg-bg-alt" data-id="element-343" data-mp="30ck1k2ae3hxz">
      <div className="max-w-[720px] mx-auto" data-id="element-344" data-mp="30bioxtdq6ne5">
        <FadeIn data-id="element-345" data-mp="34dx70b9klj4d">
          <h2 className="font-display font-bold uppercase md:text-[36px] text-center mb-8 text-txt-primary text-[22px] leading-[1.25] tracking-[0.5px]" data-id="element-346" data-mp="34eeykulaf95y">
            Si trabajas en <span className="text-brandGold" data-id="element-347" data-mp="fofej74m90zg">barbería y quieres crecer,</span>
            <br data-id="element-348" data-mp="jlv0uuh7yaly" />
            esto te va a sonar familiar...
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-349" data-mp="244nqecj3bv9a">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-card border border-line rounded-[10px] py-2.5 px-3 md:py-3 md:px-4" data-id="element-350" data-mp="203vgri6b3och" data-mpi={i}>
                <XCircle className="text-danger shrink-0 mt-0.5" size={16} data-id="element-351" data-mp="1vbkazyovx8c0" />
                <p className="text-txt-body font-sans text-[13px] md:text-[15px] leading-[1.5]" data-id="element-352" data-mp="1qdiwlr2elx6v">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Gold divider */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-353" data-mp="1gel0o32nf1du"></div>

          <h3 className="font-display font-bold uppercase md:text-[40px] text-center text-txt-primary mb-8 relative text-[24px] leading-[1.2] tracking-[0.5px]" data-id="element-354" data-mp="17hal45issq34">
            ¿Sigues con todo tu{' '}
            <span className="text-brandGold inline-block" style={{
            textShadow: '0 0 20px rgba(212,162,76,0.5), 0 0 40px rgba(212,162,76,0.3)'
          }} data-id="element-355" data-mp="31u8t2ih0zana">
              conocimiento disperso?
            </span>
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-10" data-id="element-356" data-mp="rc2x3rlvqn4j">
            <p data-id="element-357" data-mp="mcqe5hy4q078">
              Elegiste este camino porque amas transformar el look de tus
              clientes y ganar dinero en serio.
            </p>
            <p data-id="element-358" data-mp="3utbhai42xz2f">
              Pero nadie te dijo que ibas a pasar años buscando en internet, sin
              tener UN SISTEMA donde TODO esté organizado, donde NO FALLES y
              donde DOMINES realmente la colorimetría.
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border-2 border-brandGold rounded-[16px] py-5 px-5 md:py-6 md:px-8 shadow-[0_0_40px_rgba(212,162,76,0.2)]" data-id="element-359" data-mp="3knuryu3s5ta">
            <p className="font-display font-bold text-[18px] md:text-[26px] leading-[1.3] text-center text-txt-primary uppercase tracking-[0.5px]" data-id="element-360" data-mp="372frtrn3jfyc">
              ¿Y SI HOY TUVIERAS TODO LISTO PARA{' '}
              <span className="text-brandGold" data-id="element-361" data-mp="1rd6n65xwbnfp">DOMINAR LA TÉCNICA?</span>
            </p>
          </div>

          {/* Gold divider — transition to product */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mt-10 md:mt-14 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-362" data-mp="1ijutpwvtzp5n"></div>
        </FadeIn>
      </div>
    </Section>;
};